<template>
  <b-modal
    hide-footer
    size="xl"
    title="Group Market"
    centered
    id="group-market"
    @shown="handleGetListSport"
  >
    <div class="text-black pt-2 pb-2">
      <b-row>
        <!-- LIST SPORT -->
        <b-col cols="12" lg="3" style="border-right: 1px solid #dae1e7">
          <div
              v-for="(sport, index) in listSports"
              :key="sport.id"
              class="d-flex align-items-center justify-content-between p-1"
              :class="{
                'border-bot': index !== listSports.length - 1,
                'active-item': selectedSport && selectedSport.id === sport.id,
              }"
              style="cursor: pointer; gap: 16px"
              @click="handleSelectSport(sport)"
            >
              <div>
                {{ sport.name }}
              </div>
            </div>
        </b-col>
        <!-- GROUPS -->
        <b-col v-if="selectedSport" cols="12" lg="4" style="border-right: 1px solid #dae1e7">
          <div class="d-flex justify-content-between mb-1" :style="{borderBottom: groups.length === 0 ? '1px solid #dae1e7' : 'none', paddingBottom: groups.length === 0 ? '5px' : '0'}">
            <h5>GROUPS</h5>
            <b-button
              variant="primary"
              style="padding: 6px 10px; font-size: 12px"
              @click="handleShowModalAddNewGroup"
              >Add new group</b-button
            >
          </div>

          <div v-if="groups.length > 0" class="d-flex align-items-center justify-content-between mb-1">
            <p class="text-muted m-0">
              <feather-icon icon="MoveIcon" class="mr-1" />
              Drag group to reorder display priority
            </p>
            <b-button
              variant="primary"
              size="sm"
              @click="handleSaveOrder"
              style="padding: 6px 10px; font-size: 12px"
              class="ml-1"
            >
              <feather-icon icon="SaveIcon" />
              Save order
            </b-button>
          </div>
          <draggable
            v-if="groups.length > 0"
            :list="groups"
            :group="{ name: 'groups' }"
            :sort="true"
          >
            <div
              v-for="(group, index) in groups"
              :key="group.id"
              class="d-flex align-items-center justify-content-between p-1"
              :class="{
                'border-bot': index !== groups.length - 1,
                'active-item': selectedGroup && selectedGroup.id === group.id,
              }"
              style="cursor: pointer; gap: 16px"
              @click="selectGroup(group)"
            >
              <div>
                <feather-icon icon="AlignCenterIcon" class="text-muted" />
                {{ group.header }}
              </div>
              <div v-if="!!group.header">
                <feather-icon
                  v-if="
                    group.header !== 'Other' && group.header !== 'Top Markets'
                  "
                  size="18"
                  icon="TrashIcon"
                  class="text-danger cursor-pointer"
                  @click="showModal('delete-group', group)"
                />
                <feather-icon
                  v-if="
                    group.header !== 'Other' && group.header !== 'Top Markets'
                  "
                  size="18"
                  icon="EditIcon"
                  class="ml-1 text-warning cursor-pointer"
                  @click="handleEditGroup(group)"
                />
              </div>
            </div>
          </draggable>
        </b-col>
        <!-- KEYWORDS -->
        <b-col cols="12" lg="5">
          <div
            v-if="selectedGroup && selectedGroup.header"
            class="border-bottom pb-1 d-flex align-items-center justify-content-between"
          >
            <div v-if="selectedGroup" style="font-weight: 900; color: black">
              <span style="font-weight: 300">List Keywords for:</span>
              {{ selectedGroup.header }}
            </div>
            <b-button
              variant="primary"
              style="padding: 6px 10px; font-size: 12px"
              @click="showModalAddConfig"
              >Add new key</b-button
            >
          </div>

          <template v-if="!!selectedGroup && selectedGroup.header !== 'Other'">
            <div class="d-flex align-items-center justify-content-between my-1">
              <p class="text-muted m-0">
                <feather-icon icon="MoveIcon" class="mr-1" />
                Drag group to reorder display priority
              </p>
              <b-button
                variant="primary"
                size="sm"
                @click="handleSaveOrderKeyword"
                style="padding: 6px 10px; font-size: 12px"
                class="ml-1"
              >
                <feather-icon icon="SaveIcon" />
                Save order
              </b-button>
            </div>
            <draggable
              v-show="selectedGroup && selectedGroup.keywords.length"
              :list="selectedGroup.keywords"
              item-key="id"
              :group="{ name: 'keyword' }"
              class="mt-1 d-flex flex-column"
              style="gap: 5px"
            >
              <div
                v-for="(key, index) in selectedGroup.keywords"
                :key="key.id"
                class="d-flex align-items-center justify-content-between p-1 market-outline"
                style="gap: 16px"
              >
                <div class="d-flex align-items-center" style="gap: 10px">
                  <feather-icon icon="AlignCenterIcon" class="text-muted" />
                  <span>{{ index + 1 }}, {{ key.keyword }}</span>
                </div>
                <feather-icon
                  size="20"
                  icon="TrashIcon"
                  class="ml-1 text-danger cursor-pointer"
                  @click="showModal('delete-key', key)"
                />
              </div>
            </draggable>
            <div
              class="mt-3 text-center"
              v-show="!selectedGroup || !selectedGroup.keywords.length"
            >
              No item in list
            </div>
          </template>

          <template v-if="selectedGroup && selectedGroup.header === 'Other'">
            <div class="text-center font-weight-bold mt-2">
              This group will include markets that do not contain the keywords
              that have been set from other groups.
            </div>
          </template>
        </b-col>
      </b-row>

      <!-- MODAL ADD/UPDATE KEYWORD -->
      <b-modal
        ref="config"
        :title="modalTitle"
        centered
        cancel-variant="outline-secondary"
        hide-footer
        @hide="hideModalSetting"
      >
        <div style="color: black">
          <p class="m-0" style="padding-bottom: 5px">New Key</p>
          <b-form-input
            v-model="newKeyName"
            class="border"
            placeholder="Enter key ..."
          />
        </div>
        <b-row>
          <b-col class="d-flex justify-content-end mt-2">
            <b-button
              variant="primary"
              class="mb-1 mb-sm-0"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              :disabled="isLoading"
              @click="handleSaveDataConfig"
            >
              <Spinner v-if="isLoading" />
              <template v-else> Save </template>
            </b-button>
          </b-col>
        </b-row>
      </b-modal>

      <!-- MODAL ADD/UPDATE GROUP -->
      <b-modal
        ref="add-group"
        title="Market Group"
        centered
        cancel-variant="outline-secondary"
        hide-footer
        @hide="hideModalSetting"
      >
        <div style="color: black" class="mb-2">
          <p class="m-0" style="padding-bottom: 5px">Group Title</p>
          <b-form-input
            v-model="newGroup.header"
            class="border"
            placeholder="Enter title ..."
          />
          <div
            v-for="(item, ind) in newGroup.keywords"
            :key="item.id"
            style="gap: 5px"
            class="mt-1"
          >
            <b-row>
              <b-col cols="12" md="4">
                <span class="m-0" style="padding-bottom: 5px"
                  >Key Name {{ ind + 1 }}</span
                >
              </b-col>
              <b-col
                cols="12"
                md="8"
                class="d-flex align-items-center"
                style="gap: 4px"
              >
                <b-form-input
                  v-model="item.keyword"
                  class="border"
                  placeholder="Enter key ..."
                />
                <feather-icon
                  v-if="modalType === 'add'"
                  size="18"
                  icon="TrashIcon"
                  class="ml-1 text-danger cursor-pointer"
                  @click="handleDeleteKey(item)"
                />
              </b-col>
            </b-row>
          </div>
          <div
            class="d-flex justify-content-start mt-1"
            v-if="modalType === 'add'"
          >
            <b-button
              variant="primary"
              style="padding: 6px 10px; font-size: 12px"
              @click="handleAddMoreKey()"
            >
              + Add more key</b-button
            >
          </div>
        </div>
        <b-row>
          <b-col class="d-flex justify-content-end mt-2">
            <b-button
              v-if="modalType === 'add'"
              variant="primary"
              class="mb-1 mb-sm-0"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              :disabled="isLoading"
              @click="handleSaveNewGroup"
            >
              <Spinner v-if="isLoading" />
              <template v-else> Save </template>
            </b-button>
            <b-button
              v-if="modalType === 'edit'"
              variant="primary"
              class="mb-1 mb-sm-0"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              :disabled="isLoading"
              @click="handleSaveUpdateGroup"
            >
              <Spinner v-if="isLoading" />
              <template v-else> Save </template>
            </b-button>
          </b-col>
        </b-row>
      </b-modal>

      <!-- MODAL CONFIRM -->
      <b-modal
        ref="modal"
        :title="modal.title"
        centered
        cancel-variant="outline-secondary"
        :ok-disabled="isLoading"
        @ok="handleSubmitModal"
      >
        <b-card-text style="color: black">
          {{ modal.content }}
        </b-card-text>
        <template #modal-ok>
          <Spinner v-if="isLoading" />
          <span v-else>Submit</span>
        </template>
      </b-modal>
    </div>
  </b-modal>
</template>

<script>
import useToastHandler from "@/services/toastHandler";
import {
  BCard,
  BCol,
  BRow,
  BButton,
  BIcon,
  BFormCheckbox,
  BFormInput,
  BCardText,
} from "bootstrap-vue";
import { mapActions, mapState } from "vuex";
import draggable from "vuedraggable";
import Spinner from "@/@core/components/Spinner.vue";
import vSelect from "vue-select";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BIcon,
    BFormCheckbox,
    draggable,
    BFormInput,
    BCardText,
    Spinner,
    vSelect,
  },
  data() {
    return {
      groups: [],
      checkActiveSport: true,
      selectedGroup: null,
      newKeyName: "",
      modal: {
        title: "",
        content: "",
      },
      action: {
        type: "",
        id: "",
      },
      modalTitle: "",
      newGroup: {
        header: "",
        keywords: [{ id: 1, keyword: "" }],
      },
      modalType: "",
      listSports: [],
      selectedSport: null,
    };
  },
  watch: {
    selectedSport(newVal) {
      if (newVal) {
        this.fetchMarketGroups();
      }
    },
  },
  computed: {
    ...mapState("sport/market", [
      "loadingDelete",
      "loadingUpdateKey",
      "loadingUpdateOrder",
      "loadingCreateGroup",
    ]),
    isLoading() {
      return (
        this.loadingDelete || this.loadingUpdateKey || this.loadingCreateGroup
      );
    },
  },
  methods: {
    ...mapActions({
      getListSport: "sport/list/getListSport",
      getMarketGroups: "sport/market/getMarketGroups",
      createMarketGroup: "sport/market/createMarketGroup",
      updateOrderNumberGroup: "sport/market/updateOrderNumberGroup",
      updateGroupKey: "sport/market/updateGroupKey",
      deleteGroupOrKeyword: "sport/market/deleteGroupOrKeyword",
      updateOrderNumberKeyword: "sport/market/updateOrderNumberKeyword",
    }),
    async handleGetListSport() {
      const { data } = await this.getListSport({
        page: 1,
        limit: 100,
        source: "sporting",
      });
      if (Array.isArray(data)) {
        this.listSports = data;
        this.selectedSport = this.listSports[0];
      }
    },
    async fetchMarketGroups() {
      const data = await this.getMarketGroups(this.selectedSport.id);
      if (Array.isArray(data.data)) {
        this.groups = data.data;
        this.selectedGroup = this.groups[0];
      }
    },
    async selectGroup(group) {
      this.selectedGroup = group;
    },

    setModal(title, content) {
      this.modal.title = title;
      this.modal.content = content;
    },
    showModal(type, item) {
      this.action = { item, type };
      if (type === "delete-key")
        this.setModal(
          "Delete Keyword",
          `Are you sure you want to delete key name ${item.keyword}?`
        );

      if (type === "delete-group") {
        this.setModal(
          "Delete Group",
          `Are you sure you want to delete group name ${item.header}?`
        );
      }
      this.$refs.modal.show();
    },
    async handleSubmitModal(event) {
      event.preventDefault();
      const { type, item } = this.action;
      if (type === "delete-key") await this.handleDeleteKeyword(item);
      if (type === "delete-group") await this.handleDeleteGroup(item);

      if (!this.isLoading) {
        this.$nextTick(() => {
          this.$refs.modal.hide();
        });
      }
    },
    async handleSaveDataConfig(event) {
      event.preventDefault();
      if (!this.newKeyName)
        return this.showToastError(false, "Please enter key name");
      const res = await this.updateGroupKey({
        marketGroups: [
          {
            id: this.selectedGroup.id,
            keywords: [
              {
                keyword: this.newKeyName,
              },
            ],
          },
        ],
      });
      if (res) {
        this.showToastSuccess(true, "Add key successfully!");
        this.$refs.config.hide();
        this.handleReload();
      }
    },
    showModalAddConfig() {
      this.modalTitle = "New Key";
      this.$refs.config.show();
    },
    hideModalSetting() {
      this.newKeyName = "";
      this.newGroup = {
        header: "",
        keywords: [{ id: 1, keyword: "" }],
      };
    },
    async handleDeleteKeyword(item) {
      const res = await this.deleteGroupOrKeyword({
        keywordId: item.id,
        marketGroupId: item.marketGroupId,
      });
      if (res) {
        this.showToastSuccess(true, "Key deleted successfully!");
        this.handleReload();
      }
    },
    async handleDeleteGroup(item) {
      const res = await this.deleteGroupOrKeyword({
        marketGroupId: item.id,
      });
      if (res) {
        this.showToastSuccess(true, "Group deleted successfully!");
        await this.handleReload();
        this.selectedGroup = this.groups[0];
      }
    },
    async handleReload() {
      await this.fetchMarketGroups();
      this.selectedGroup = this.groups.find(
        (i) => i.header === this.selectedGroup.header
      );
    },
    showModalAddGroup() {
      this.modalTitle = "Add New Group";
    },
    handleAddMoreKey() {
      this.newGroup.keywords = [
        ...this.newGroup.keywords,
        {
          id: this.newGroup.keywords[this.newGroup.keywords.length - 1].id + 1,
          keyword: "",
        },
      ];
    },
    handleDeleteKey(item) {
      this.newGroup.keywords = this.newGroup.keywords.filter(
        (i) => i.id !== item.id
      );
    },
    async handleSaveNewGroup(event) {
      event.preventDefault();
      if (
        !this.newGroup.header ||
        !this.newGroup.keywords.some((i) => !!i.keyword)
      )
        return this.showToastError(false, "Please enter group information");
      const res = await this.createMarketGroup({
        sportId: this.selectedSport.id,
        header: this.newGroup.header,
        keywords: this.newGroup.keywords
          .filter((i) => !!i.keyword)
          .map((i) => i.keyword),
      });
      if (res) {
        this.showToastSuccess(true, "Add new group successfully!");
        this.$refs["add-group"].hide();
        this.handleReload();
      }
    },
    async handleSaveUpdateGroup(event) {
      event.preventDefault();
      if (
        !this.newGroup.header ||
        this.newGroup.keywords.some((i) => !i.keyword)
      )
        return this.showToastError(false, "Please enter group information");
      const res = await this.updateGroupKey({
        marketGroups: [
          {
            id: this.selectedGroup.id,
            header: this.newGroup.header,
            keywords: this.newGroup.keywords,
          },
        ],
      });
      if (res) {
        this.showToastSuccess(true, "Add new group successfully!");
        this.$refs["add-group"].hide();
        this.handleReload();
      }
    },
    async handleSaveOrder() {
      if (this.groups[0].header !== "Top Markets")
        return this.showToastError(
          false,
          "Top Markets always is in the first list!"
        );
      const res = await this.updateOrderNumberGroup({
        marketGroups: this.groups.map((i, ind) => {
          return {
            id: i.id,
            orderNumber: ind + 1,
          };
        }),
      });
      if (res) {
        this.showToastSuccess(true, "Updated group order successfully!");
        this.handleReload();
      }
    },
    async handleSaveOrderKeyword() {
      const res = await this.updateOrderNumberKeyword({
        marketGroups: [
          {
            id: this.selectedGroup.id,
            keywords: this.selectedGroup.keywords.map((keyword, idx) => {
              return {
                id: keyword.id,
                orderNumber: idx + 1,
              };
            }),
          },
        ],
      });
      if (res) {
        this.showToastSuccess("success", "Updated keyword order successfully!");
      }
    },
    handleEditGroup(group) {
      this.modalType = "edit";
      this.$refs["add-group"].show();
      this.newGroup.header = group.header;
      this.newGroup.keywords = group.keywords.map((key, ind) => {
        return {
          id: key.id,
          keyword: key.keyword,
        };
      });
    },
    handleShowModalAddNewGroup() {
      this.newGroup = {
        header: "",
        keywords: [{ id: 1, keyword: "" }],
      };
      this.modalType = "add";
      this.$refs["add-group"].show();
    },
    handleSelectSport(sport) {
      this.selectedSport = sport;
    },
  },
  setup() {
    const { showToastError, showToastSuccess } = useToastHandler();
    return {
      showToastError,
      showToastSuccess,
    };
  },
};
</script>

<style lang="scss" scoped>
.border-bot {
  border-bottom: 1px solid #dae1e7;
}

.active-item {
  color: #0d6efd;
  font-weight: bold;
  border-left: 2px solid #0d6efd;
  background: #e7f1ff;
}

.market-outline {
  padding: 20px;
  border: 1px solid #dae1e7;
  border-radius: 10px;
}
</style>
